<script setup> 
import FileDownloadButton from '@/Components/Uploads/FileDownloadButton.vue'
import FileDeleteButton from '@/Components/Uploads/FileDeleteButton.vue'
import { DocumentDownloadIcon } from "@heroicons/vue/outline"

const props = defineProps({
	params: {
		type: Object,
		required: true,
	},
})


//handler functions for click events, emit events don't appear to function

function fileDeleted() {
	props.params.fileDeleted(props.params.value)
}


</script>

<template>
		<span class="flex">
			<FileDownloadButton :id="props.params" />
			<FileDeleteButton :id="props.params" @file-deleted="fileDeleted" />
		</span>
</template>



